export default (state = [], action) => {
  switch (action.type) {
    case "IS_PREMIUM":
      return { ...state,premium:action.premium };
    case "INVALID PARAMETERS":
      return {...state,premium:false}
    default:
      return state;
  }
};
